/**
 * Provide some global constants.
 */

//export const greenColorCode = '#1F3864';
//export const lightGreenColorCode = 'white';

export const ColorCode = {
    background : 'white',
    darkBlue : '#1F3864',
    lightBlue : '#A1C4E9',
    vlightBlue : '#FBFFFF',
    darkYellow : '#806000',
    lightYellow : '#E7C21E',
    vlightYellow : '#FFFFFB'
};